"use client";

import { createContext, useContext, ReactNode, useCallback, useMemo } from "react";

interface CommandPaletteContextType {
  openCommandPalette: () => void;
  closeCommandPalette: () => void;
  isOpen: boolean;
}

const CommandPaletteContext = createContext<
  CommandPaletteContextType | undefined
>(undefined);

export function CommandPaletteProvider({ children }: { children: ReactNode }) {
  const openCommandPalette = useCallback(() => {}, []);
  const closeCommandPalette = useCallback(() => {}, []);
  const isOpen = false;
  const value = useMemo(
    () => ({ openCommandPalette, closeCommandPalette, isOpen }),
    [openCommandPalette, closeCommandPalette, isOpen],
  );

  return <CommandPaletteContext value={value}>{children}</CommandPaletteContext>;
}

export function useCommandPalette() {
  const context = useContext(CommandPaletteContext);
  if (context === undefined) {
    throw new Error(
      "useCommandPalette must be used within a CommandPaletteProvider",
    );
  }
  return context;
}
